import React from "react";
const swatches = [{
  id: 1,
  capColor: "#FFFFFF",
  coreColor: "#171717",
  label: "White on Black"
}, {
  id: 2,
  capColor: "#171717",
  coreColor: "#FFFFFF",
  label: "Black on White"
}, {
  id: 3,
  capColor: "#FFFFFF",
  coreColor: "#DC2626",
  label: "White on Red"
}, {
  id: 4,
  capColor: "#FFFFFF",
  coreColor: "#2563EB",
  label: "White on Blue"
}, {
  id: 5,
  capColor: "#171717",
  coreColor: "#FACC15",
  label: "Black on Yellow"
}, {
  id: 6,
  capColor: "#FFFFFF",
  coreColor: "#16A34A",
  label: "White on Green"
}];
export default function StockColors() {
  return <section id="stockcolors" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-6">
            What Colors Does Phenolic Come In?
          </h2>
          <p className="text-lg text-muted-foreground">
            Two-color phenolic is engraved so the core color shows through the cap. Evermark Industrial Solutions stocks the common control-panel combinations; exact available combinations are confirmed at quote.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8">
          {swatches.map((swatch, i) => <div key={swatch.id} data-index={i} className="flex flex-col items-center gap-4">
              <div className="w-full aspect-[4/3] rounded-md border border-border shadow-sm flex items-center justify-center relative overflow-hidden" style={{
            backgroundColor: swatch.capColor
          }} aria-hidden="true">
                {}
                <span className="font-default font-bold text-3xl tracking-widest select-none" style={{
              color: swatch.coreColor
            }}>
                  123
                </span>
                {}
                <div className="absolute inset-0 rounded-md pointer-events-none"></div>
              </div>
              <span className="font-default font-medium text-sm text-foreground text-center">
                {swatch.label}
              </span>
            </div>)}
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <p className="text-sm text-muted-foreground max-w-2xl mx-auto bg-muted/30 p-5 rounded-lg border border-border/50">Full stock color list and core/cap combinations. Custom and premium colors may be available on request.</p>
        </div>
      </div>
    </section>;
}